export default __webpack_public_path__ + "static/media/story-caption-brush.3b321f17.png";